
import React from 'react';
import {
	Route,
	Redirect,
} from 'react-router-dom';
import { getCurrentUser } from './Utils';
import { isAuthGuardActive } from '../constants/defaultValues';

const ProtectedRoute = ({ component: Component, roles = undefined, ...rest }) => {
	const setComponent = (props) => {
		if (isAuthGuardActive) {
			const currentUser = getCurrentUser();
			if (currentUser) {
				
				if (roles) {
					// console.log('check roles: ',roles);
					
					if (roles) {
					
						return <Component {...props} />;
					} else {
						// console.log('check roles: ',roles);
						// console.log('check current user: ',currentUser)
						
						return <Redirect
							to={{
								pathname: '/unauthorized',
								state: { from: props.location },
							}} />
					}
				} else {
					return <Component {...props} />;
				}
			} else {
				return <Redirect
					to={{
						pathname: '/user/login',
						state: { from: props.location },
					}} />
			}
		} else {
			return <Component {...props} />;
		}

	}

	return (
		<Route
			{...rest}
			render={setComponent}
		/>
	);
}
//may be to be used in future
const UserRole = {
	Admin: 0,
	Editor: 1,
	SuperAdministrator: "SuperAdministrator",
	CUSTOMER_ADMINISTRATOR: "CustomerAdministrator",
	ADMINISTRATOR_USER: "AdministratorUser",
	CUSTOMER_USER: "CustomerUser"

}

export { ProtectedRoute, UserRole };
